import { useAuth } from "@/modules/growing-circle/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

const ROLE_LABEL = { admin: "Administrator", author: "Author / Founder", facilitator: "Facilitator", member: "Member" };

export default function Profile() {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl">
      <p className="eyebrow mb-4">My space</p>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight mb-10">{user?.name}</h1>

      <div className="bg-card border border-border rounded-3xl p-8 space-y-5">
        <Row label="Email" value={user?.email} />
        <Row label="Role" value={ROLE_LABEL[user?.role] || user?.role} />
        {user?.edition && <Row label="Book edition" value={user.edition} />}
      </div>

      {isAdmin && (
        <div className="mt-6 bg-secondary/50 border border-border rounded-3xl p-8">
          <div className="flex items-center gap-3 mb-2">
            <ShieldCheck className="w-6 h-6 text-primary" />
            <h2 className="font-heading text-2xl">Back office</h2>
          </div>
          <p className="text-muted-foreground text-sm mb-5">Manage verifications, users, content, testimonies and meetings.</p>
          <Button className="btn-gold rounded-full text-sm font-medium" onClick={() => navigate("/growing-circle/admin")} data-testid="profile-admin-btn">Open the back office</Button>
        </div>
      )}

      <div className="mt-6 bg-card border border-border rounded-3xl p-8">
        <h2 className="font-heading text-2xl mb-2">Privacy</h2>
        <p className="text-muted-foreground text-sm leading-relaxed">
          Every testimony you write has a visibility that you choose: to the community, anonymously, or only to those who listen.
          The images submitted to verify the book are not kept after approval and are never used for biometric recognition.
        </p>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between items-center border-b border-border pb-4 last:border-0 last:pb-0">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-sm font-medium">{value}</span>
    </div>
  );
}
